import { Grid } from "@mui/material";
import React from "react";
import { Create, TextInput, NumberInput, AutocompleteInput, required, BooleanInput } from "react-admin";
import { CountryEnum } from "src/common/enum";
import { PhoneInput, StateInput } from "src/components/input";
import { FormTab, TabbedForm } from "src/enterprise/ra-rbac";
import Transformer from "src/common/Transformer";
import { TeritoryCreateComponent } from "./TeritoryComponent";

export const TerritoryCreate = () => {
  const transform = (data) => {
    Transformer(data, {
      update: {
        main: data.main !== null ? data.main.toString() : "false",
        international: data.international !== null ? data.international.toString() : "false",
        showroom: data.showroom !== null ? data.showroom.toString() : "false",
      }
    });

    return data;
  };

  return (
    <Create component={TeritoryCreateComponent} transform={transform}>
      <TabbedForm>
        <FormTab label="General" name="general">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={6}>
              <TextInput source="legacy_id" label="Legacy ID"/>
            </Grid> 
            <Grid item sm={12} lg={6}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={6}>
              <TextInput source="email" type="email" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={6}>
              <PhoneInput source="phone" label="Phone" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={3}>
              <NumberInput source="commission" />
            </Grid>
            <Grid item sm={12} lg={3}>
              <NumberInput source="sample_rating" />
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="Address" name="general">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={6}>
              <TextInput source="shipping_name" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={6}>
              <TextInput source="street_address" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={3}>
              <TextInput source="city" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={3}>
              <TextInput source="zip" validate={required()} />
            </Grid>

            <Grid item sm={12} lg={3}>
              <AutocompleteInput
                source="country"
                size="small"
                choices={CountryEnum.slice(1)}
                sx={{
                  "#state": { width: "100%" },
                }}
                emptyValue={""}
                validate={required()}
              />
            </Grid>
            <Grid item sm={12} lg={3}>
              <StateInput />
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="Showroom" name="showroom">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={6}>
              <BooleanInput source="showroom"></BooleanInput>
            </Grid>
            <Grid item sm={12} lg={6}>
              <Grid container rowSpacing={1} columnSpacing={2}>
                <Grid item sm={12} lg={6}>
                  <BooleanInput source="main"></BooleanInput>
                </Grid>
                <Grid item sm={12} lg={6}>
                  <BooleanInput source="international"></BooleanInput>
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm={12} lg={6}>
              <TextInput source="title"/>
            </Grid>
            <Grid item sm={12} lg={6}>
              <TextInput source="serve"/>
            </Grid>
          </Grid>
        </FormTab>
      </TabbedForm>
    </Create>
  );
};
